import { BasicCTA, CTAProps } from "components/base/CTA/CTA"
import { CTA } from "SiteComponents"
import useWindowSize from "src/utils/useWindowSize"

const CtaLinkBlock = (props: CTAProps) => {
  const isDesktop = useWindowSize().width > 768
  return <CTA {...props} size={isDesktop ? "medium" : "small" }/>
}

export default CtaLinkBlock;